import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import { ROAST_CONFIG } from './config.js';

export default {
    runCookieConsent() {
        const logo = '<img src="data:image/svg+xml;base64,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" alt="Drivalia" style="width: 150px;margin-left: -4px;margin-bottom: -5px;">';

        CookieConsent.run({
            revision: 4,
            disablePageInteraction: true,

            cookie: {
                name: 'dr_cookie',
            },

            guiOptions: {
                consentModal: {
                    layout: 'cloud',
                    position: 'bottom center',
                    equalWeightButtons: true,
                    flipButtons: false
                },
                preferencesModal: {
                    layout: 'box',
                    position: "right",
                    equalWeightButtons: true,
                    flipButtons: false
                }
            },

            onFirstConsent: () => {
                logConsent();
            },

            onChange: () => {
                logConsent();
            },

            categories: {
                necessary: {
                    enabled: true,
                    readOnly: true
                },
                functionality: {},
                analytics: {
                    autoClear: {
                        cookies: [
                            {
                                name: /^(_ga|_gid)/
                            }
                        ]
                    }
                },
                marketing: {}
            },

            language: {
                default: 'cs',
                autoDetect: 'document',
                translations: {
                    cs: {
                        consentModal: {
                            title: 'Informace o nastavení cookies',
                            description: `Na našich webových stránkách používáme soubory cookies. Některé z nich jsou nezbytné, zatímco jiné nám pomáhají vylepšit tento web a váš uživatelský zážitek. Více o cookies se dočtete v <a href="` + '#/cookie-policy' + `" target="_blank">zásadách cookies</a>.`,
                            acceptAllBtn: 'Povolit vše',
                            acceptNecessaryBtn: 'Odmítnout vše',
                            showPreferencesBtn: 'Nastavení',
                        },
                        preferencesModal: {
                            title: logo,
                            acceptAllBtn: 'Souhlasím se všemi cookies',
                            acceptNecessaryBtn: 'Odmítnout vše',
                            savePreferencesBtn: 'Souhlasím s vybranými cookies',
                            closeIconLabel: 'Zavřít',
                            sections: [
                                {
                                    title: 'Použití cookies',
                                    description: 'Soubory cookie používáme k zajištění základních funkcí webu a ke zlepšení vašeho uživatelského zážitku. Souhlas pro každou kategorii můžete kdykoliv změnit.'
                                },
                                {
                                    title: 'Technické cookies <span class="pm__badge">nezbytné pro fungování webu</span>',
                                    description: 'Technické cookies jsou potřeba kvůli správnému fungování webu, bezpečnosti, správnému zobrazování na počítači nebo na mobilu, fungujícímu vyplňování i odesílání formulářů a podobně. Tyto soubory cookies si můžete deaktivovat v nastavení Vašeho prohlížeče, ale bez nich může webová stránka nabízet pouze omezený rozsah služeb a informací.',
                                    linkedCategory: 'necessary',
                                    cookieTable: {
                                        headers: {
                                            name: 'Název',
                                            duration: 'Doba',
                                            desc: 'Popis'
                                        },
                                        body: [
                                            {
                                                name: 'servis_session',
                                                duration: '2 hodiny',
                                                desc: 'Tento relační cookie informuje o tom, že aktivně používáte tuto stránku. Prostřednictvím tohoto souboru jsou k dispozici informace o počtu aktuálních uživatelů stránky. Tento cookie se vymaže ve chvíli, kdy zavřete váš prohlížeč.'
                                            },
                                            {
                                                name: 'XSRF-TOKEN',
                                                duration: '2 hodiny',
                                                desc: 'Tento soubor cookie je napsán, aby pomohl se zabezpečením webu a zabránil útokům typu Cross-Site Request Forgery.'
                                            },
                                            {
                                                name: '_GRECAPTCHA',
                                                duration: '182 dní',
                                                desc: 'Google reCAPTCHA nastavuje nezbytný soubor cookie (_GRECAPTCHA), když je spuštěn za účelem poskytnutí analýzy rizik.',
                                            },
                                            {
                                                name: 'dr_cookie',
                                                duration: '182 dní',
                                                desc: 'Cookie používaná bannerem k uložení souhlasů.'
                                            }
                                        ]
                                    }
                                },
                                {
                                    title: 'Analytické a výkonnostní cookies',
                                    description: 'Analytické a výkonnostní cookies nám umožňují měření výkonu našeho webu a našich reklamních kampaní. Jejich pomocí určujeme počet návštěv a zdroje návštěv našich internetových stránek. Data získaná pomocí těchto cookies zpracováváme souhrnně, bez použití identifikátorů, které ukazují na konkrétní uživatelé našeho webu. Pokud vypnete používání analytických a výkonnostních cookies ve vztahu k Vaší návštěvě, ztrácíme možnost analýzy výkonu a optimalizace našich opatření.',
                                    linkedCategory: 'analytics',
                                    cookieTable: {
                                        headers: {
                                            name: 'Název',
                                            duration: 'Doba',
                                            desc: 'Popis'
                                        },
                                        body: [
                                            {
                                                name: '_ga',
                                                duration: '2 roky',
                                                desc: 'Ve výchozím nastavení analytics.js knihovna používá jediný soubor cookie s názvem _ga, ukládá jedinečný identifikátor relace cílení/reklama klienta (Client ID), což je náhodně generované číslo. Jakmile je ID, je generován je uložen v souboru cookie a je součástí každé odpovědi odeslané do služby Google Analytics.'
                                            },
                                            {
                                                name: '_gid',
                                                duration: '1 den',
                                                desc: 'Používaný službou Google Analytics, ukládá informace o tom, jak návštěvníci používají webové stránky, a zároveň vytváří analytickou zprávu o výkonu webových stránek. Mezi shromažďované údaje patří počet návštěvníků, jejich zdroj a anonymně navštívené stránky..'
                                            },
                                            {
                                                name: '_gat',
                                                duration: '1 minuta',
                                                desc: 'Tato cookie je asociována s Google Analytics Universal, dle dokumentace se používá k omezení počtu požadavků na stránkách s vysokou návštěvností.'
                                            },
                                            {
                                                name: '_clck',
                                                duration: '1 rok',
                                                desc: 'Uchovává Clarity User ID a preference specifické pro daný web, což zajišťuje, že akce provedené během následujících návštěv stejné webové stránky budou spojeny se stejným uživatelským ID.',
                                            },
                                            {
                                                name: '_clsk',
                                                duration: '1 den',
                                                desc: 'Ukládá a konsoliduje zobrazení stránek uživatele do záznamu jedné relace.',
                                            },
                                            {
                                                name: 'CLID',
                                                duration: '1 rok',
                                                desc: 'Identifikuje, kdy Clarity poprvé zaznamenala tohoto uživatele na jakémkoli webu využívajícím Clarity.',
                                            },
                                            {
                                                name: 'ANONCHK',
                                                duration: '10 minut',
                                                desc: 'Udává, zda je MUID přenesen do ANID, souboru cookie používaného pro reklamu. Clarity nepoužívá ANID, a proto je tento údaj vždy nastaven na 0.',
                                            },
                                            {
                                                name: 'MR',
                                                duration: '7 dní',
                                                desc: 'Určuje, zda se má obnovit identifikátor MUID.',
                                            },
                                            {
                                                name: 'MUID',
                                                duration: '1 rok 24 dní',
                                                desc: 'Identifikuje jedinečné webové prohlížeče navštěvující stránky společnosti Microsoft. Tyto soubory cookie se používají pro reklamu, analýzu stránek a další provozní účely.',
                                            },
                                            {
                                                name: 'SM',
                                                duration: 'session',
                                                desc: 'Používá se při synchronizaci identifikátoru MUID v doménách Microsoft.',
                                            }
                                        ]
                                    }
                                },
                                {
                                    title: 'Personalizované a reklamní cookies',
                                    description: 'Personalizované a reklamní cookies jsou obvykle nastaveny našimi partnery. Používají se pro průzkum zájmu uživatele a následného zobrazení reklamy s relevantním obsahem. Pokud tyto cookies nepovolíte, reklama nebude přizpůsobená podle Vašich zájmů.',
                                    linkedCategory: 'marketing',
                                    cookieTable: {
                                        headers: {
                                            name: 'Název',
                                            duration: 'Doba',
                                            desc: 'Popis'
                                        },
                                        body: [
                                            {
                                                name: '_fbp',
                                                duration: '89 dní',
                                                desc: 'Používá Facebook k poskytování řady reklamních produktů, jako jsou nabídky v reálném čase od inzerentů třetích stran.',
                                            },
                                            {
                                                name: 'test_cookie',
                                                duration: '1 den',
                                                desc: 'Používá se ke kontrole, zda prohlížeč uživatele podporuje soubory cookies.'
                                            }
                                        ]
                                    }
                                },
                                {
                                    title: 'Více informací',
                                    description: `Více o cookies se dočtete v <a href="` + '#/cookie-policy' + `" target="_blank">zásadách cookies</a>.`
                                }
                            ]
                        }
                    },
                    en: {
                        consentModal: {
                            title: 'Information about cookie settings',
                            description: `On our website, we use cookies. Some of them are essential, while others help us improve this website and your user experience. You can learn more about cookies in our <a href="` + '#/cookie-policy' + `" target="_blank">cookie policy</a>.`,
                            acceptAllBtn: 'Allow All',
                            acceptNecessaryBtn: 'Reject All',
                            showPreferencesBtn: 'Settings',
                        },
                        preferencesModal: {
                            title: logo,
                            acceptAllBtn: 'Allow all cookies',
                            acceptNecessaryBtn: 'Reject all cookies',
                            savePreferencesBtn: 'Allow selected cookies',
                            closeIconLabel: 'Close',
                            sections: [
                                {
                                    title: 'Use of cookies',
                                    description: 'We use cookies to ensure essential website functions and enhance your user experience. You can change your consent for each category at any time.'
                                },
                                {
                                    title: 'Technical Cookies <span class="pm__badge">necessary for the functioning of the website</span>',
                                    description: 'Technical cookies are needed for the proper functioning of the website, security, correct display on your computer or mobile phone, for filling out and submitting forms, etc. You can deactivate these cookies in your browser settings, but without them the website can only offer a limited range of services and information.',
                                    linkedCategory: 'necessary',
                                    cookieTable: {
                                        headers: {
                                            name: 'Name',
                                            duration: 'Duration',
                                            desc: 'Description'
                                        },
                                        body: [
                                            {
                                                name: 'servis_session',
                                                duration: '2 hours',
                                                desc: 'This session cookie indicates that you are actively using this page. It provides information about the number of active users on the page. This cookie is deleted when you close your browser.'
                                            },
                                            {
                                                name: 'XSRF-TOKEN',
                                                duration: '2 hours',
                                                desc: 'This cookie is written to help with site security in preventing Cross-Site Request Forgery attacks.',
                                            },
                                            {
                                                name: '_GRECAPTCHA',
                                                duration: '182 days',
                                                desc: 'Google reCAPTCHA sets a necessary cookie (_GRECAPTCHA) when executed for the purpose of providing its risk analysis.',
                                            },
                                            {
                                                name: 'dr_cookie',
                                                duration: '182 days',
                                                desc: 'Cookie used by the banner to store consents.',
                                            }
                                        ]
                                    }
                                },
                                {
                                    title: 'Analytical and Performance Cookies',
                                    description: 'Analytical and performance cookies allow us to measure the performance of our website and our advertising campaigns. With their help, we determine the number of visits and the sources of traffic to our website. The data obtained through these cookies is processed in an aggregate manner, without using identifiers that point to specific users of our website. If you disable the use of analytical and performance cookies during your visit, we lose the ability to analyze performance and optimize our measures.',
                                    linkedCategory: 'analytics',
                                    cookieTable: {
                                        headers: {
                                            name: 'Name',
                                            duration: 'Duration',
                                            desc: 'Description'
                                        },
                                        body: [
                                            {
                                                name: '_ga',
                                                duration: '2 years',
                                                desc: 'By default, the analytics.js library uses a single cookie named _ga to store a unique session targeting/advertising client identifier (Client ID), which is a randomly generated number. Once generated, it is stored in the cookie and included in each response sent to Google Analytics.'
                                            },
                                            {
                                                name: '_gid',
                                                duration: '1 day',
                                                desc: 'Used by Google Analytics to store information about how visitors use the website and to create an analytical report about the performance of the website. The collected data includes the number of visitors, their source, and anonymously visited pages.'
                                            },
                                            {
                                                name: '_gat',
                                                duration: '1 minute',
                                                desc: 'This cookie is associated with Google Analytics Universal. According to the documentation, it is used to limit the number of requests on websites with high traffic.'
                                            },
                                            {
                                                name: '_clck',
                                                duration: '1 year',
                                                desc: 'Stores Clarity User ID and site-specific preferences, ensuring that actions performed during future visits to the same website are associated with the same user ID.'
                                            },
                                            {
                                                name: '_clsk',
                                                duration: '1 day',
                                                desc: 'Stores and consolidates user page views into a single session record.'
                                            },
                                            {
                                                name: 'CLID',
                                                duration: '1 year',
                                                desc: 'Identifies when Clarity first recorded this user on any website using Clarity.'
                                            },
                                            {
                                                name: 'ANONCHK',
                                                duration: '10 minutes',
                                                desc: 'Indicates whether MUID is transferred to ANID, a cookie used for advertising. Clarity does not use ANID, so this is always set to 0.'
                                            },
                                            {
                                                name: 'MR',
                                                duration: '7 days',
                                                desc: 'Determines whether the MUID identifier should be refreshed.'
                                            },
                                            {
                                                name: 'MUID',
                                                duration: '1 year 24 days',
                                                desc: 'Identifies unique web browsers visiting Microsoft websites. These cookies are used for advertising, site analytics, and other operational purposes.'
                                            },
                                            {
                                                name: 'SM',
                                                duration: 'session',
                                                desc: 'Used during the synchronization of the MUID identifier across Microsoft domains.'
                                            }
                                        ]
                                    }
                                },
                                {
                                    title: 'Personalized and Advertising Cookies',
                                    description: 'Personalised and advertising cookies are usually set by our partners. They are used to research the user\'s interest and then display advertisements with relevant content. If you do not allow these cookies, advertising will not be tailored to your interests.',
                                    linkedCategory: 'marketing',
                                    cookieTable: {
                                        headers: {
                                            name: 'Name',
                                            duration: 'Duration',
                                            desc: 'Description'
                                        },
                                        body: [
                                            {
                                                name: '_fbp',
                                                duration: '89 days',
                                                desc: 'Used by Facebook to provide a range of advertising products, such as real-time offers from third-party advertisers.'
                                            },
                                            {
                                                name: 'test_cookie',
                                                duration: '1 day',
                                                desc: 'Used to check if the user\'s browser supports cookies.'
                                            }
                                        ]
                                    }
                                },
                                {
                                    title: 'More information',
                                    description: `You can find more information about cookies in our <a class="cc-link" href="` + '#/cookie-policy' + `" target="_blank">cookie policy</a>.`
                                }
                            ]
                        }
                    }
                }
            }
        });

        function logConsent() {
            const cookie = CookieConsent.getCookie();
            const preferences = CookieConsent.getUserPreferences();

            const userConsent = {
                consentId: cookie.consentId,
                domain: window.location.hostname,
                data: {
                    cookie: cookie,
                    preferences: preferences,
                },
                timestamp: cookie.lastConsentTimestamp,
            };

            fetch(ROAST_CONFIG.COOKIE_CONSENT_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userConsent)
            });
        }
    },
};
